module.exports = __webpack_public_path__ + "static/button_app_store-32d6936986e05fca885c7fbd75c5091c.svg";